<template>
  <div class="login-bg">
    <div class="container">
      <div class="row justify-content-center mb-4">
        <div class="col-12 text-center">
          <h2
            v-bind:style="{
              color: '#fff',
              fontWeight: 'bold',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.9)',
            }"
          >
            {{ tagline }}
          </h2>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="card rounded-lg">
          <b-row class="mt-2 ml-2">
            <b-col md="12">
              <div class="pl-4 pr-5">
                <h4 class="d-flex align-items-center">
                  <router-link button to="/login-with">
                    <b-icon icon="arrow-left-short"></b-icon>
                  </router-link>
                  {{ $t("login") }}
                </h4>
                <p class="">
                  {{ $t("logintoDiscover") }}
                  <br />
                  {{ $t("newTo") }} {{ appName }}?
                  <router-link
                    to="/register"
                    style="text-decoration: underline"
                  >
                    {{ $t("createAccount") }}
                  </router-link>
                </p>
              </div>
            </b-col>
          </b-row>
          <div class="card-body pl-5 pr-5">
            <div v-if="!otpKey && loginType !== 'otp'" class="form-group">
              <label for="phone">{{ $t("contactUs.email") }} :</label>
              <input
                id="phone"
                v-model="phone"
                type="text"
                class="form-control"
                :placeholder="$t('contactUs.emailPlaceholder')"
                required
              />
            </div>
            <div v-if="!otpKey && loginType == 'otp'" class="form-group">
              <label for="phone">{{ $t("contactUs.phone") }} :</label>
              <input
                id="phone"
                v-model="phone"
                type="text"
                class="form-control"
                :placeholder="$t('contactUs.phonePlaceholder')"
                required
                @keydown="handlePhoneKey"
              />
            </div>

            <!-- Password Field -->
            <div
              class="form-group position-relative"
              v-if="!otpKey && loginType !== 'otp'"
            >
              <label for="password">{{ $t("password") }} :</label>
              <input
                id="password"
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                class="form-control pr-5"
                :placeholder="$t('password')"
                required
              />
              <span class="toggle-password" @click="togglePasswordVisibility">
                <i
                  :class="showPassword ? 'mdi mdi-eye-off' : 'mdi mdi-eye'"
                ></i>
              </span>
            </div>
            <div class="text-right pb-2" v-if="!otpKey && loginType !== 'otp'">
              <router-link
                to="/forgot-password"
                style="text-decoration: underline"
                >{{ $t("forgotPassword") }}</router-link
              >
            </div>
            <div v-if="otpKey" class="row justify-content-md-center">
              <div class="text-center">
                <form class="mt-4 mb-4">
                  <input
                    v-model="otpInput1"
                    v-on:keyup="$event.target.nextElementSibling.focus()"
                    class="otp border"
                    type="text"
                    maxlength="1"
                  />
                  <input
                    v-model="otpInput2"
                    v-on:keyup="$event.target.nextElementSibling.focus()"
                    class="otp border"
                    type="text"
                    maxlength="1"
                  />
                  <input
                    v-model="otpInput3"
                    v-on:keyup="$event.target.nextElementSibling.focus()"
                    class="otp border"
                    type="text"
                    maxlength="1"
                  />
                  <input
                    v-model="otpInput4"
                    class="otp border"
                    v-on:keyup="$event.target.nextElementSibling.focus()"
                    type="text"
                    maxlength="1"
                  />
                </form>
                <p :style="{ color: otpMsg.key }">
                  {{ otpMsg.value }}
                </p>
              </div>
            </div>
            <!-- <div v-if="otpKey && !isLoading" style="text-align: center">
              Not Recieved Your Code?
              <b v-if="countDownObj.countDownVar > 0"
                ><a id="resendCode" class="modal-title-otp-timer"
                  >Resend Code in {{ countDownObj.msg }}
                </a>
              </b>
              <b v-else class="modal-title-otp"
                ><a id="resendCode" @click="() => this.login()">Resend Code OTP </a>
              </b>
            </div> -->

            <div class="pt-4 form-group text-center">
              <template v-if="!isLoading">
                <b-button
                  v-if="!otpKey && loginType !== 'otp'"
                  class="primary-btn"
                  size="lg"
                  @click="() => loginWithPsw()"
                  >{{ $t("signIn") }}
                </b-button>
                <b-button
                  v-if="otpKey || loginType == 'otp'"
                  size="lg"
                  style="display: block; width: 100%"
                  @click="() => loginOtp()"
                  >{{ $t("loginwithOTP") }}</b-button
                >
              </template>

              <template v-if="isLoading">
                <b-spinner
                  v-for="i in 3"
                  :key="i"
                  class="mr-1"
                  small
                  label="Small Spinner"
                  type="grow"
                ></b-spinner>
              </template>
            </div>

            <!--  <template v-if="!otpKey">
              <div class="text-center pt-3">
									<p>Login Using</p>
								</div>
              <div class="form-group text-center">
                <button
										@click="facebookLogin"
										class="mr-3 fa-facebook"
										size=""
									>
										<b-icon
											icon="facebook"
											aria-label="Help"
										></b-icon>
										Facebook
									</button>
                <button
										@click="googleLogin"
										class="ml-3 fa-google"
										size=""
									>
										<b-icon
											icon="google"
											aria-label="Help"
										></b-icon>
										Google
									</button>
                <GoogleLogin
                      :params="params"
                      :onSuccess="onSuccess"
                      :onFailure="onFailure"
                      style=""
                      class="fa-google"
                    >
                      <b-icon icon="google" aria-label="Help"></b-icon>
                      Google</GoogleLogin
                    >
              </div>
            </template>-->
            <!-- <p v-if="!otpKey" class="pt-2" style="font-size: 12px">
              By continuing, you agree to Indian Mangoes
              <router-link
                to="/terms_conditions"
                style="text-decoration: underline"
                >Terms & Conditions</router-link
              >
              of Use and<router-link
                to="/privacy-policy"
                style="text-decoration: underline"
              >
                Privacy Policy</router-link
              >
            </p> -->
            <div
              class="d-flex justify-content-center align-item-center mt-4 mb-3"
              v-if="!otpKey"
            ></div>
            <div class="d-flex justify-content-center gap-6 mt-4">
              <!-- Gmail (updated from Phone) -->
              <b-button
                v-if="loginType == 'otp'"
                variant="light"
                class="circle-btn border"
                @click="
                  () => {
                    $route.query.type = 'email';
                    loginType = 'email';
                    otpKey = false;
                    phone = '';
                  }
                "
              >
                <b-icon icon="envelope-fill" class="me-2"></b-icon>
              </b-button>
              <b-button
                v-else
                variant="light"
                class="circle-btn border"
                @click="loginType = 'otp'"
              >
                <b-icon icon="telephone-fill" font-scale="1.2"></b-icon>
              </b-button>
              <!-- Google -->
              <b-button
                variant="light"
                class="circle-btn border"
                @click="googleLogin"
              >
                <img
                  src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                  alt="Google"
                  class="icon-img"
                />
              </b-button>

              <!-- Facebook -->
              <b-button
                variant="light"
                class="circle-btn border"
                @click="facebookLogin"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_%282019%29.png"
                  alt="Facebook"
                  class="icon-img"
                />
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import GoogleLogin from "vue-google-login";
import { socialLoginSignup } from "../auth.services";
import { mapState } from "vuex";
import {
  GoogleAuthProvider,
  FacebookAuthProvider,
  getAuth,
  signInWithPopup,
} from "firebase/auth";
import config from "/public/config.json";
export default {
  name: "login",
  components: {
    //  GoogleLogin,
  },
  computed: {
    ...mapState({
      cartData: (state) => state.checkout.cartData,
    }),
  },
  data() {
    return {
      phone: "",
      password: "",
      otpMsg: { value: "", key: "" },
      otpKey: false,
      loginType: "password",
      otpInput1: "",
      otpInput2: "",
      otpInput3: "",
      otpInput4: "",
      isLoading: false,
      appName: config.appName,
      tagline: config.tagline,
      passwordRules: [(v) => !!v || "Password is required"],
      showPassword: false,
      countDownObj: {
        countDownVar: 0,
        msg: "",
      },
    };
  },

  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    timerFunc() {
      this.countDownObj.countDownVar = 60;
      this.countDownObj.msg = `00 : ${this.countDownObj.countDownVar}`;
      clearInterval(countDownIntervalFunc);
      const countDownIntervalFunc = setInterval(() => {
        this.countDownObj.countDownVar--;
        if (this.countDownObj.countDownVar < 10) {
          this.countDownObj.msg = `00 : 0${this.countDownObj.countDownVar}`;
        } else if (this.countDownObj.countDownVar > 10) {
          this.countDownObj.msg = `00 : ${this.countDownObj.countDownVar}`;
        }
        if (this.countDownObj.countDownVar < 0) {
          clearInterval(countDownIntervalFunc);
        }
      }, 1000);
    },
    googleLogin() {
      const x = new GoogleAuthProvider();
      signInWithPopup(getAuth(), x)
        .then(async (res) => {
          try {
            let result = await socialLoginSignup({
              data: {
                accessToken: res._tokenResponse.oauthIdToken,
              },
              type: "GOOGLE",
            });
            if (result.data.response.registration) {
              result = await socialLoginSignup({
                data: {
                  accessToken: res._tokenResponse.oauthIdToken,
                  category: "CUSTOMER",
                },
                type: "GOOGLE",
              });
            }
            result.data.response.user.name.first = res._tokenResponse.firstName;
            result.data.response.user.name.last = res._tokenResponse.lastName;
            // result.data.response.user.extendedAttributes.profilePhoto=res._tokenResponse.photoUrl;
            const userdata = {
              ...result.data.response.user,
              loginType: "social",
            };
            if (result) {
              const token = await result.data.response.token;
              localStorage.setItem(
                `${process.env.VUE_APP_TENANT}:access_token`,
                token
              );
              localStorage.setItem(
                `${process.env.VUE_APP_TENANT}:userInfo`,
                JSON.stringify(userdata)
              );
              this.$store.dispatch("auth/loginToken", token);
              this.$store.dispatch("auth/setUserData", userdata);
              this.$store.commit(
                "address/setDeliveryAddress",
                userdata.addresses
              );
              setTimeout(() => {
                this.$router.push("/");
              }, 1500);
            }
          } catch (error) {
            console.log(error);
          }
        })
        .catch((err) => {
          console.log("google err", err);
        });
    },
    facebookLogin() {
      const x = new FacebookAuthProvider();
      signInWithPopup(getAuth(), x)
        .then(async (res) => {
          const credential = FacebookAuthProvider.credentialFromResult(res);
          const accessToken = credential.accessToken;
          try {
            let result = await socialLoginSignup({
              data: {
                accessToken: accessToken,
              },
              type: "FACEBOOK",
            });

            if (result.data.response.registration) {
              result = await socialLoginSignup({
                data: {
                  accessToken: accessToken,
                  category: "CUSTOMER",
                },
                type: "FACEBOOK",
              });
            }
            result.data.response.user.name.first = res._tokenResponse.firstName;
            result.data.response.user.name.last = res._tokenResponse.lastName;
            // result.data.response.user.extendedAttributes.profilePhoto=res._tokenResponse.photoUrl;
            const userdata = {
              ...result.data.response.user,
              loginType: "social",
            };
            if (result) {
              const token = await result.data.response.token;
              localStorage.setItem(
                `${process.env.VUE_APP_TENANT}:access_token`,
                token
              );
              localStorage.setItem(
                `${process.env.VUE_APP_TENANT}:userInfo`,
                JSON.stringify(userdata)
              );
              this.$store.dispatch("auth/loginToken", token);
              this.$store.dispatch("auth/setUserData", userdata);
              this.$store.commit(
                "address/setDeliveryAddress",
                userdata.addresses
              );
              setTimeout(() => {
                this.$router.push("/");
              }, 1500);
            }
          } catch (error) {
            console.log(error);
          }
        })
        .catch((err) => {
          console.log("google err", err);
        });
    },
    validatePhone(value) {
      if (!value) return false;
      const cleaned = value.trim();
      return /^(\+1\s?)?(\(?\d{3}\)?[\s.-]?)\d{3}[\s.-]?\d{4}$/.test(cleaned);
    },
    handlePhoneKey(e) {
      const key = e.key;

      // Allow control/navigation keys
      const allowed = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"];
      if (allowed.includes(key)) return;

      // Allow digits, (, ), -, and space
      if (!/^[\d()\-\s]$/.test(key)) {
        e.preventDefault();
        return;
      }

      // Remove non-digit characters for digit count check
      const digitsOnly = this.phone.replace(/\D/g, "");

      // Limit to 10 digits
      if (/^\d$/.test(key) && digitsOnly.length >= 10) {
        e.preventDefault();
      }
    },
    async loginOtp() {
      const payload = {};
      payload.mobile = this.phone;
      if (this.otpInput1) {
        payload.otp =
          this.otpInput1 + this.otpInput2 + this.otpInput3 + this.otpInput4;
      } else {
        let check = this.validatePhone(payload.mobile);
        if (!check) {
          this.$swal({
            type: "error",
            title: "Missing Fields",
            text: "Please provide phone with correct format.",
          });
          return;
        }
      }
      this.isLoading = true;
      await this.$store
        .dispatch("auth/callLogin", payload)
        .then(async (result) => {
          if (!this.otpInput1) {
            this.otpKey = true;
            this.isLoading = false;
            return;
          }
          const token = await result.data.response.token;
          if (token) {
            localStorage.setItem(
              `${process.env.VUE_APP_TENANT}:access_token`,
              token
            );
            localStorage.setItem(
              `${process.env.VUE_APP_TENANT}:userInfo`,
              JSON.stringify(result.data.response.user)
            );
            this.$store.dispatch("auth/loginToken", token);
            this.$store.dispatch("auth/setUserData", result.data.response.user);
            this.$store.commit(
              "address/setDeliveryAddress",
              result.data.response.user.addresses
            );
            setTimeout(() => {
              this.$router.push("/");
              this.isLoading = false;
            }, 1500);
          }
        })
        .catch((err) => {
          console.log(err);
          this.otpMsg = { value: "Invalid Verification", key: "red" };
          this.otpInput1 =
            this.otpInput2 =
            this.otpInput3 =
            this.otpInput4 =
              "";
          this.isLoading = false;
        });
    },
    async onSuccess(googleUser) {
      const authDetails = googleUser.getAuthResponse();
      // const basicProfileDetail = googleUser.getBasicProfile();
      try {
        const result = await socialLoginSignup({
          data: {
            accessToken: authDetails.id_token,
          },
          type: "GOOGLE",
        });
        // result.data.response.user.name.first= res._tokenResponse;
        const userdata = {
          ...result.data.response.user,
          loginType: "social",
        };
        if (result) {
          const token = await result.data.response.token;
          //const user = await result.data.response.user;
          localStorage.setItem(
            `${process.env.VUE_APP_TENANT}:access_token`,
            token
          );
          localStorage.setItem(
            `${process.env.VUE_APP_TENANT}:userInfo`,
            JSON.stringify(userdata)
          );
          this.$store.dispatch("auth/loginToken", token);
          this.$store.dispatch("auth/setUserData", userdata);
        }
      } catch (error) {
        console.log(error);
      }
    },
    onFailure(error) {
      console.log(error);
    },
    async loginWithPsw() {
      try {
        if (!this.phone || !this.password) {
          this.$swal({
            type: "error",
            title: "Missing Fields",
            text: "Please fill in all required fields.",
          });
          return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^[6-9]\d{9}$/;
        if (emailRegex.test(this.phone)) {
          this.email = this.phone;
          this.mobile = Math.round(Date.now() / 1000).toString();
        } else if (phoneRegex.test(this.phone)) {
          this.mobile = this.phone;
          this.email =
            "sha256" +
            Math.random().toString(36).substring(2, 15) +
            Math.random().toString(36).substring(2, 15) +
            "@indianmangoes.com";
        } else {
          this.$swal({
            type: "error",
            title: "Invalid Input",
            text: "Please enter a valid email address or 10-digit phone number.",
          });
          return;
        }
        const isEmail = this.phone.includes("@");

        const payload = {
          ...(isEmail ? { email: this.phone } : { phone: this.phone }),
          password: this.password,
        };
        await this.$store
          .dispatch("auth/loginWithPassword", payload)
          .then(async (result) => {
            const token = await result.data.response.token;
            if (token) {
              localStorage.setItem(
                `${process.env.VUE_APP_TENANT}:access_token`,
                token
              );
              localStorage.setItem(
                `${process.env.VUE_APP_TENANT}:userInfo`,
                JSON.stringify(result.data.response.user)
              );
              this.$store.dispatch("auth/loginToken", token);
              this.$store.dispatch(
                "auth/setUserData",
                result.data.response.user
              );
              this.$store.commit(
                "address/setDeliveryAddress",
                result.data.response.user.addresses
              );
              setTimeout(() => {
                this.$router.push("/");
                this.isLoading = false;
              }, 1500);
            }
          });
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "An unexpected error occurred";
        this.$swal({
          type: "error",
          title: errorMessage,
          confirmButtonColor: "#FF5733",
        });
        this.isLoading = false;
      }
    },
    async login() {
      this.isLoading = true;
      try {
        const payload = {};
        payload.mobile = this.phone;
        const result = await this.$store.dispatch("auth/callLogin", payload);
        if (result.response) {
          let msg = result.response.data.message;
          this.$swal({
            text: msg,
            type: "error",
          });
        }
        if (result.data.status == 1) {
          this.otpKey = true;
          this.otpMsg = { value: result.data.message, key: "green" };
          this.timerFunc();
        } else {
          this.otpMsg = { value: "can not send otp", key: "red" };
        }
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
  },
  mounted() {
    if (this.$route.query.type == "otp") {
      this.loginType = "otp";
      // this.otpKey = true;
    }
  },
};
</script>
<style scoped>
.bi-arrow-left-short {
  height: 3rem;
  width: 3rem;
  color: var(--primarycolor);
  padding: 0px;
}

.bi-arrow-left-short:hover {
  color: var(--darkcolor);
}
.login-heading {
  margin-left: 40px;
}
.logo p {
  font-size: 1rem;
}
.toggle-password {
  position: absolute;
  top: 70%;
  right: 15px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #666;
  font-size: 1.25rem;
  z-index: 10;
  line-height: 1;
}
.password-field >>> .v-input__append-inner {
  cursor: pointer;
}
::v-deep .v-messages__message {
  color: red;
}
.password-field >>> .v-icon {
  background: none !important;
  padding: 0 !important;
  margin-right: 4px;
  color: #666;
}
.fa-facebook {
  border: 1px solid rgb(60, 90, 154);
  color: rgb(60, 90, 154);
  padding: 7px 15px;
  border-radius: 0.25rem;
}

.fa-facebook:hover {
  background: rgb(60, 90, 154);
  color: #fff !important;
}

.fa-google {
  border: 1px solid rgb(220, 74, 61);
  color: rgb(220, 74, 61);
  padding: 7px 15px;
  border-radius: 0.25rem;
}

.fa-google:hover {
  background: rgb(220, 74, 61);
  color: #fff !important;
}

.otp {
  margin-right: 10px;
}

form input {
  display: inline-block;
  width: 50px;
  height: 50px;
  text-align: center;
}

.login-bg {
  background-image: url("/img/login/login_bg_img.png");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 2rem 1rem;
}
.login-bg::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: url("/img/login/login_bg_img.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transform: scaleX(-1);
  z-index: -1;
  opacity: 0.4;
}
.bg-orange {
  background: linear-gradient(var(--primarycolor), var(--darkcolor));
}
.modal-title-otp a:hover {
  text-decoration: underline !important;
}

.primary-btn {
  background: var(--primarycolor);
  color: #fff;
  border-color: var(--primarycolor);
  padding: 0.5rem 8rem;
}

.is-valid-phone {
  font-size: 14px;
  margin-top: 5px;
  margin-left: 9px;
  color: red;
}

.border {
  border: 1px solid #000;
}

.modal-title-otp {
  color: #579a70;
  cursor: pointer;
}

.loginBtn {
  box-sizing: border-box;
  position: relative;
  /* width: 13em;  - apply for fixed size */
  margin: 0.2em;
  padding: 0 15px 0 46px;
  border: none;
  text-align: left;
  line-height: 34px;
  white-space: nowrap;
  border-radius: 0.2em;
  font-size: 16px;
  color: #fff;
  width: 65%;
}

.circle-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 15px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
}

.icon-img {
  height: 24px;
  width: 24px;

  object-fit: contain;
}
#login-shopping-heading {
  font-weight: 400;
}
@media (max-width: 768px) {
  h2 {
    font-size: 20px !important;
    padding: 0 10px;
  }
  .primary-btn {
    width: 100%;
    font-size: 16px;
    white-space: normal;
  }
  .card {
    margin: 20px auto;
    padding: 20px 15px;
  }

  .form-group {
    margin-bottom: 1rem;
  }

  .v-input input {
    font-size: 16px;
  }

  .checkbox p {
    font-size: 13px;
  }

  .primary-btn {
    font-size: 16px;
    padding: 0.75rem;
  }

  .logo img {
    width: 60px;
  }
}
@media (max-width: 768px) {
  .login-left-side.pt-3 {
    padding-top: 0 !important;
  }

  .login-left-side h2 {
    font-size: 20px;
    margin-bottom: 0;
    text-align: center;
  }

  img.login-logo-icon.img-fluid {
    width: 30px;
  }

  #login-shopping-heading {
    margin-top: 0px !important;
    font-size: 20px;
    text-align: center;
    padding-bottom: 0 !important;
  }

  .btn-primary {
    padding: 0.5rem 1.5rem;
  }

  img.mt-2.teka-login-logo {
    margin-top: 0 !important;
  }
}
.logo img {
  width: 100%;
  max-width: 88;
  max-height: 91px;
  object-fit: cover;
}
.card {
  max-width: 500px;
  width: 100%;
  margin-left: auto;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
</style>
